import supabase from '../supabase/supabase';

const TABLE = 'site_images';

export const imageService = {
  getAll: async () => {
    const { data, error } = await supabase
      .from(TABLE)
      .select('*')
      .order('section_key', { ascending: true })
      .order('sort_order', { ascending: true });
    if (error) throw error;
    return data || [];
  },

  updateUrl: async (id, image_url) => {
    const { error } = await supabase
      .from(TABLE)
      .update({ image_url, updated_at: new Date().toISOString() })
      .eq('id', id);
    if (error) throw error;
  },
};